import { ReactElement } from "react";
import { SpinnerLegacy } from "../../../../components";
import { useSupplier } from "../../../../hooks/api/v2/supplier/useSupplier";
import { UserSignupFlow } from "../../signIn/UserSignupFlow";

export function UserSignupStepSupplier({
  supplierIdOrUrlId,
}: {
  supplierIdOrUrlId: string;
}): ReactElement {
  const supplierQuery = useSupplier(supplierIdOrUrlId, {
    enabled: !!supplierIdOrUrlId,
    refetchOnWindowFocus: false,
  });

  if (supplierQuery.isLoading) return <SpinnerLegacy />;

  return <UserSignupFlow supplier={supplierQuery.data} />;
}
